if (!customElements.get('collection-sort')) {
  // The top-bar sort select sits outside the filter form (it's tied to it
  // with form="filter-sorting-form"), so its changes don't bubble to the
  // form's input listener. Re-dispatch them on the form so the existing
  // filter script (FilterForm in theme.js) re-renders the grid. The top bar
  // is replaced after every filter change; this element re-binds each time.
  customElements.define(
    'collection-sort',
    class extends HTMLElement {
      connectedCallback() {
        const select = this.querySelector('select');
        if (!select || this.bound) return;
        this.bound = true;
        select.addEventListener('change', () => {
          if (select.form) select.form.dispatchEvent(new Event('input', { bubbles: true }));
        });
      }
    }
  );
}
